import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export type ViewFieldControlPayload = {
  kind: 'viewFieldControl';
  viewNodeId: string;
  fieldName: string;
  fieldType: string;
  overrideFieldName: boolean;
  onPatch: (patch: {
    id: string;
    fieldName?: string;
    fieldType?: string;
    overrideFieldName?: boolean;
  }) => void;
};

@Component({
  selector: 'app-viewfield-control',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './viewfield-control.component.html',
  styleUrl: './viewfield-control.component.scss',
})
export class ViewFieldControlComponent {
  @Input({ required: true }) data!: ViewFieldControlPayload;

  toggleOverride(next: boolean): void {
    this.data.onPatch({ id: this.data.viewNodeId, overrideFieldName: next });
  }

  changeFieldName(next: string): void {
    this.data.onPatch({ id: this.data.viewNodeId, fieldName: next });
  }

  changeFieldType(next: string): void {
    this.data.onPatch({ id: this.data.viewNodeId, fieldType: next });
  }
}

